import {
  configApiRef,
  useApi,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { WorkloadClient } from '@internal/workload-api-helper';
import { OrgUnitEntry } from '../types';

export const useAllowedOrgUnit = () => {
  const [allowedOrgUnits, setAllowedOrgUnits] = useState<OrgUnitEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const config = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);

  const workloadClient = useMemo(
    () => new WorkloadClient(config, oauthApi),
    [config, oauthApi],
  );

  const fetchAllowedOrgUnits = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await workloadClient.apiFetch(`org-units`);

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const data = await response.json();
      let json_body;
      try {
        json_body = JSON.parse(data.body);
      } catch (parseError: any) {
        throw new Error(
          `Failed to parse JSON from org-units response: ${parseError.message}`,
        );
      }
      const org_units = json_body.org_units;

      setAllowedOrgUnits(org_units || []); // Assuming the API returns { 'org-units': OrgUnitEntry[] }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [workloadClient]);

  useEffect(() => {
    fetchAllowedOrgUnits();
  }, [fetchAllowedOrgUnits]);

  return { allowedOrgUnits, loading, error };
};
